import { render, staticRenderFns } from "./meTrait.vue?vue&type=template&id=56fb9bdb&scoped=true&"
import script from "./meTrait.vue?vue&type=script&lang=js&"
export * from "./meTrait.vue?vue&type=script&lang=js&"
import style0 from "./meTrait.vue?vue&type=style&index=0&id=56fb9bdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb9bdb",
  null
  
)

export default component.exports